module.exports = __webpack_public_path__ + "img/product_112.68bac39.webp";